(() => {
  const FIELD_KEYS = {
    childName: { required: true, en: "Child's name", el: 'Όνομα παιδιού' },
    age: { required: true, en: 'Age', el: 'Ηλικία' },
    birthdayDate: { required: true, en: 'Birthday date', el: 'Ημερομηνία γενεθλίων' },
    birthdayTime: { required: true, en: 'Birthday time', el: 'Ώρα γενεθλίων' },
    location: { required: true, en: 'Location / venue', el: 'Τοποθεσία / χώρος' },
    additionalText: { required: false },
    theme: { required: true, en: 'Theme / description', el: 'Θέμα / περιγραφή' },
    preferredColors: { required: false },
    style: { required: true, en: 'Visual style', el: 'Οπτικό στυλ' },
  };

  const COPY = {
    en: {
      missingTitle: '⚠️ Missing information:',
      creating: 'Creating your invitation...',
      network: 'Network error. Check your connection and try again.',
      server: 'A server error occurred. Please try again later.',
      api: 'The invitation could not be created. Please try again in a moment.',
      image: 'Image generation failed. Please try again.',
      rate: 'Too many requests. Please wait and try again.',
      cooldown: 'Please wait a few seconds before generating again.',
      session_limit: 'You have reached the maximum number of generations for this visit.',
      lock: 'Generate and select a design before adding this invitation to the cart.',
    },
    el: {
      missingTitle: '⚠️ Λείπουν στοιχεία:',
      creating: 'Δημιουργία της πρόσκλησής σας...',
      network: 'Σφάλμα δικτύου. Ελέγξτε τη σύνδεσή σας και δοκιμάστε ξανά.',
      server: 'Προέκυψε σφάλμα διακομιστή. Δοκιμάστε ξανά αργότερα.',
      api: 'Δεν ήταν δυνατή η δημιουργία της πρόσκλησης. Δοκιμάστε ξανά σε λίγο.',
      image: 'Η δημιουργία εικόνας απέτυχε. Δοκιμάστε ξανά.',
      rate: 'Πάρα πολλά αιτήματα. Περιμένετε και δοκιμάστε ξανά.',
      cooldown: 'Περιμένετε λίγα δευτερόλεπτα πριν δημιουργήσετε ξανά.',
      session_limit: 'Φτάσατε τον μέγιστο αριθμό δημιουργιών για αυτή την επίσκεψη.',
      lock: 'Δημιουργήστε και επιλέξτε σχέδιο πριν προσθέσετε την πρόσκληση στο καλάθι.',
    },
  };

  const PROPERTY_MAP = [
    ['childName', 'Child Name'],
    ['age', 'Age'],
    ['birthdayDate', 'Birthday Date'],
    ['birthdayTime', 'Birthday Time'],
    ['location', 'Location'],
    ['theme', 'Theme'],
    ['style', 'Style'],
    ['additionalText', 'Additional Text'],
    ['imageUrl', 'Generated Invitation URL'],
  ];

  function pack(locale) {
    return String(locale || '').toLowerCase().startsWith('el') ? COPY.el : COPY.en;
  }

  function label(locale, key) {
    const lang = String(locale || '').toLowerCase().startsWith('el') ? 'el' : 'en';
    return FIELD_KEYS[key][lang];
  }

  class AIInvitationGenerator {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('[data-ai-form]');
      this.errorEl = root.querySelector('[data-ai-error]');
      this.generateBtn = root.querySelector('[data-ai-generate]');
      this.generateLabel = root.querySelector('[data-ai-generate-label]');
      this.loadingCopy = root.querySelector('[data-ai-loading-copy]');
      this.preview = root.querySelector('[data-ai-preview]');
      this.image = root.querySelector('[data-ai-image]');
      this.againBtn = root.querySelector('[data-ai-again]');
      this.useBtn = root.querySelector('[data-ai-use]');
      this.selectedNote = root.querySelector('[data-ai-selected]');
      this.locale = root.dataset.locale || 'en';
      this.apiBase = (root.dataset.apiBase || '').replace(/\/$/, '');
      this.clientId = root.dataset.clientId || 'ai-invitation-generator';
      this.maxGenerations = Number(root.dataset.maxGenerations || 5);
      this.lockCart = root.dataset.lockCart !== 'false';
      this.busy = false;
      this.sessionToken = '';
      this.lastPayload = null;
      this.selected = false;
      this.originalGenerateText = this.generateLabel ? this.generateLabel.textContent : '';
      this.generationCount = Number(sessionStorage.getItem('aiInvitationCount') || 0);

      this.bind();
      if (this.lockCart) this.setCartLocked(true);
      this.ensureSession();
    }

    bind() {
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.generate();
      });
      this.againBtn.addEventListener('click', () => this.generate());
      this.useBtn.addEventListener('click', () => this.useDesign());
    }

    productForm() {
      return document.querySelector('form[data-type="add-to-cart-form"]');
    }

    setCartLocked(locked) {
      const form = this.productForm();
      if (!form) return;
      const submit = form.querySelector('[name="add"], .product-form__submit');
      const nativeDisabled = submit && submit.hasAttribute('disabled') && !submit.dataset.aiLock;
      document.body.classList.toggle('ai-invitation-locked', locked);
      if (submit && !nativeDisabled) {
        if (locked) {
          submit.disabled = true;
          submit.dataset.aiLock = 'true';
          submit.removeAttribute('data-ai-unlocked');
        } else {
          submit.disabled = false;
          delete submit.dataset.aiLock;
          submit.setAttribute('data-ai-unlocked', 'true');
        }
      }
      form.querySelectorAll('.shopify-payment-button button, .shopify-payment-button input').forEach((el) => {
        el.disabled = locked;
      });

      if (!form.dataset.aiInvitationGuard) {
        form.dataset.aiInvitationGuard = 'true';
        form.addEventListener('submit', (event) => {
          if (this.lockCart && !this.selected) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.showError(pack(this.locale).lock);
          }
        });
      }
    }

    showError(message) {
      this.errorEl.hidden = false;
      this.errorEl.textContent = message;
    }

    clearError() {
      this.errorEl.hidden = true;
      this.errorEl.textContent = '';
    }

    readFields() {
      const data = new FormData(this.form);
      const fields = {};
      Object.keys(FIELD_KEYS).forEach((key) => {
        fields[key] = String(data.get(key) || '').trim();
      });
      return fields;
    }

    validate(fields) {
      const missing = [];
      Object.entries(FIELD_KEYS).forEach(([key, meta]) => {
        if (meta.required && !fields[key]) missing.push(key);
      });
      return missing;
    }

    missingMessage(missing) {
      const lines = missing.map((key) => `• ${label(this.locale, key)}`);
      return `${pack(this.locale).missingTitle}\n${lines.join('\n')}`;
    }

    setLoading(isLoading) {
      this.busy = isLoading;
      this.generateBtn.disabled = isLoading;
      this.againBtn.disabled = isLoading;
      this.useBtn.disabled = isLoading;
      this.generateBtn.classList.toggle('is-loading', isLoading);
      this.loadingCopy.hidden = !isLoading;
      this.generateLabel.textContent = isLoading ? pack(this.locale).creating : this.originalGenerateText;
    }

    async ensureSession() {
      if (!this.apiBase || this.sessionToken) return;
      try {
        const response = await fetch(`${this.apiBase}/api/session`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Invitation-Client': this.clientId,
          },
          body: JSON.stringify({ locale: this.locale }),
        });
        const json = await this.safeJson(response);
        if (json && json.ok && json.token) this.sessionToken = json.token;
      } catch (error) {
        console.warn('AI invitation session failed', error);
      }
    }

    async safeJson(response) {
      const text = await response.text();
      if (!text) return null;
      try {
        return JSON.parse(text);
      } catch {
        return null;
      }
    }

    async generate() {
      if (this.busy) return;
      this.clearError();

      const fields = this.readFields();
      const missing = this.validate(fields);
      if (missing.length) {
        this.showError(this.missingMessage(missing));
        return;
      }

      if (this.generationCount >= this.maxGenerations) {
        this.showError(pack(this.locale).session_limit);
        return;
      }

      if (!this.apiBase) {
        this.showError(pack(this.locale).server);
        return;
      }

      await this.ensureSession();
      this.setLoading(true);
      this.lastPayload = fields;

      try {
        const response = await fetch(`${this.apiBase}/api/generate`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Invitation-Client': this.clientId,
          },
          body: JSON.stringify({
            ...fields,
            locale: this.locale,
            sessionToken: this.sessionToken,
            website: this.form.querySelector('[name="website"]').value,
          }),
        });

        const json = await this.safeJson(response);
        if (!response.ok || !json || !json.ok) {
          const code = json && json.code;
          this.showError((json && json.message) || pack(this.locale)[code] || pack(this.locale).api);
          return;
        }

        this.generationCount += 1;
        sessionStorage.setItem('aiInvitationCount', String(this.generationCount));
        this.image.src = json.imageUrl;
        this.preview.hidden = false;
        this.selected = false;
        this.selectedNote.hidden = true;
        this.lastPayload.imageUrl = json.imageUrl;
        this.preview.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (error) {
        this.showError(pack(this.locale).network);
      } finally {
        this.setLoading(false);
      }
    }

    useDesign() {
      if (!this.lastPayload || !this.lastPayload.imageUrl) return;
      const form = this.productForm();
      if (!form) return;

      PROPERTY_MAP.forEach(([field, propertyName]) => {
        const name = `properties[${propertyName}]`;
        let input = form.querySelector(`input[name="${name}"]`);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          form.appendChild(input);
        }
        const value = field === 'imageUrl' ? this.lastPayload.imageUrl : this.lastPayload[field] || '';
        input.value = value;
      });

      this.selected = true;
      this.selectedNote.hidden = false;
      this.setCartLocked(false);
    }
  }

  function boot() {
    document.querySelectorAll('[data-ai-invitation]').forEach((root) => {
      if (root.dataset.booted) return;
      root.dataset.booted = 'true';
      new AIInvitationGenerator(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
